import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/images/logo-footer.png";
import { useGetGeneralSettingsQuery } from "../../features/front/FrontAPI";
const Footer = ({ mainFooter }) => {
  const { data: generalSettingsRes } = useGetGeneralSettingsQuery();
const settings = generalSettingsRes?.data;
  return (
    <>
      {mainFooter ? (
        <footer>
          <Container>
            <Row className="align-items-center">
              <Col md={6} className="mb-md-0 mb-3">
                <div className="footer_logo text-md-start text-center">
                  <img
                    src={logo}
                    alt="Company Logo – Your Brand Name"
                    title="Your Brand Name"
                    loading="lazy"
                    decoding="async"
                    //width="150" // optional, set actual dimensions
                    height="50" // optional, set actual dimensions
                  />
                </div>
              </Col>
              <Col md={6}>
               <div className="social_icon">
  <ul className="p-0 m-0"  style={{ minHeight: "40px" }}>

    {settings?.facebookLink && (
      <li>
        <a
          href={settings.facebookLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FontAwesomeIcon icon={faFacebookF} size="1x" />
        </a>
      </li>
    )}

    {settings?.instagramLink && (
      <li>
        <a
          href={settings.instagramLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FontAwesomeIcon icon={faInstagram} size="1x" />
        </a>
      </li>
    )}

    {settings?.linkedinLink && (
      <li>
        <a
          href={settings.linkedinLink.replace(/\s+/g, "")}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedinIn} size="1x" />
        </a>
      </li>
    )}

    {settings?.youtubeLink && (
      <li>
        <a
          href={settings.youtubeLink.replace(/\s+/g, "")}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Youtube"
        >
          <FontAwesomeIcon icon={faYoutube} size="1x" />
        </a>
      </li>
    )}

  </ul>
</div>
              </Col>
            </Row>

            <div className="footer_copyright_links">
              <Row className="align-items-center">
                <Col md={6} className="text-md-start text-center">
                  <p>
                    Copyright © {new Date().getFullYear()} BlueBridge Group Placement Corp.
                    All Rights Reserved.
                  </p>

                </Col>
                <Col md={6}>
                  <ul>
                    <li>
                      <Link to="/contact-us">Contact us</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About us</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Container>
        </footer>
      ) : (
        <>
          {/* <footer className="inner_footer">
            <Container>
              <p>
                Copyright © 2025 BlueBridge Group Placement Corp.. All Rights
                Reserved.
              </p>
            </Container>
          </footer> */}
        </>


      )}
    </>
  );
};

export default Footer;
